import { render, staticRenderFns } from "./removePassengerModal.vue?vue&type=template&id=7ddd43d6&scoped=true&"
import script from "./removePassengerModal.vue?vue&type=script&lang=ts&"
export * from "./removePassengerModal.vue?vue&type=script&lang=ts&"
import style0 from "./removePassengerModal.vue?vue&type=style&index=0&id=7ddd43d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd43d6",
  null
  
)

export default component.exports